var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-70 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v("Ihre Registrierung war erfolgreich")
                ])
              ]),
              _vm._v(" "),
              _c("md-card-content", [
                _c("p", [
                  _vm._v(
                    "\n            Bitte überprüfen Sie ihr Postfach um die Registrierung zu\n            bestätigen.\n          "
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74470bd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74470bd1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/authentication/signup/success/SignupSuccess.vue
// module id = null
// module chunks = 